import { Brick, registerBrick, Query, Predicate } from 'olympe';
import ApplicationEvents from './models/Application Event'
export default class GetApplicationEvents extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} eventType
     * @param {array} eventTypes
     * @param {string} eventCode
     * @param {DateTime} createdAfter
     * @param {function()} forwardEvent
     * @param {function(*)} setEvents
     */
    async update($, [eventType, eventTypes, eventCode, createdAfter], [forwardEvent, setEvents]) {
        let query = Query.instancesOf(ApplicationEvents);

        const predicates = [];
        if (eventType) {
            predicates.push(Predicate.equals(ApplicationEvents.eventTypeProp, eventType));
        } else if (eventTypes && eventTypes.length > 0) {
            const typePredicates = eventTypes.map(type =>
                Predicate.equals(ApplicationEvents.eventTypeProp, type)
            );
            predicates.push(Predicate.or(...typePredicates));
        }
        if (eventCode) {
            predicates.push(Predicate.equals(ApplicationEvents.eventCodeProp, eventCode));
        }
        if (createdAfter) {
            const after =
                createdAfter instanceof Date ? createdAfter : new Date(createdAfter);

            predicates.push(
                Predicate.greaterThan(ApplicationEvents.createdOnProp, after)
            );
        }
        if (predicates.length > 0) {
            const combined = predicates.reduce((acc, p) => acc ? Predicate.and(acc, p) : p, null);
            query = query.filter(combined);
        }

        const results = await query.execute();
        setEvents(results);forwardEvent();
    }
}

registerBrick('0199a436ea2b044dd4fa', GetApplicationEvents);
